import { useState, useCallback } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import {
  getAllExpenses,
  createExpense,
  updateExpense,
  deleteExpense,
} from "../../../services/expenseService";
import { Expense, ExpenseCreatePayload, ExpenseUpdatePayload } from "../../../types/expenseTypes";

export const useExpense = () => {
  const { t } = useTranslation();
  const [expenses, setExpenses] = useState<Expense[]>();
  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // UI state
  const [selectedExpense, setSelectedExpense] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const fetchExpenses = useCallback(async (params: { [key: string]: string | number | null } = {}) => {
    setLoading(true);
    try {
      const response = await getAllExpenses(params);
      setExpenses(response.data);
      setPagination(response.pagination)
      setError(null);
    } catch (err) {
      console.error(err);
      setExpenses([]);
      message.error(t("failed_to_fetch_expenses"));
      setError(t("failed_to_fetch_expenses"));
    } finally {
      setLoading(false);
    }
  }, [t]);

  const handleCreate = async (formData: FormData) => {
    try {
      await createExpense(formData as any);
      message.success(t("expense_added_successfully"));
      await fetchExpenses();
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const handleUpdate = async (expenseId: string, payload: any) => {
    try {
      console.log("payload", payload);
      await updateExpense(expenseId, payload);
      message.success(t("expense_updated_successfully"));
      await fetchExpenses();
      return true;
    } catch (err) {
      console.error(err);
      message.error(t("failed_to_update_expense"));
      return false;
    }
  };

  const handleDelete = async (expenseId: string) => {
    try {
      await deleteExpense(expenseId);
      message.success(t("expense_deleted_successfully"));
      await fetchExpenses();
      return true;
    } catch (err) {
      console.error(err);
      message.error(t("failed_to_delete_expense"));
      return false;
    }
  };

  return {
    expenses: expenses,
    infoPagination: {
      total: pagination.total,
      page: pagination.page,
      limit: pagination.limit,
    },
    loading,
    error,
    selectedExpense,
    setSelectedExpense,
    isModalOpen,
    setIsModalOpen,
    fetchExpenses,
    handleCreate,
    handleUpdate,
    handleDelete,
    pagination
  };
};

export default useExpense;
